import { useToPng } from '@hugocxl/react-to-image';
import DownloadIcon from '@mui/icons-material/Download';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { Accordion,AccordionDetails,AccordionSummary,Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import OpenPrintBase64 from '../../helpers/OpenPrintBase64';
import { CreateUpdateBody,ModeloQRCode } from '../../types/checklist/types';
import {
  AnswerParagraph,
  AnswersContainer,
  ButtonsQR,
  ContentContainer,
  QRCodeDiv,
  QrCodeWithButtonsContainer,
  RowContainer,
  SubitemParagraph,
  TitleQR,
} from './Modal/StylesQRCode';

function RenderOptions({ renderBody, modeloQrCode }: { renderBody: CreateUpdateBody, modeloQrCode: ModeloQRCode }) {
  const { t } = useTranslation('translation');
  const findNameInModel: (indexItem: number, indexSubitem: number) => string = (indexItem: number, indexSubitem: number) => {
    let result = "-";
    Object.keys(modeloQrCode).forEach((key: string) => {
      const splittedKey = key.split("||");
      if (Number(splittedKey[0]) === indexItem && Number(splittedKey[1]) === indexSubitem) {
        result = modeloQrCode[key].nome;
      }
    });
    return result;
  };

  return (
    <AnswersContainer>
      {Object.values(renderBody.respostasModelo).map(val => (
        <>
          <RowContainer>
            <SubitemParagraph>
              {findNameInModel(val.itemId, val.subitemId)}:
            </SubitemParagraph>
            <AnswerParagraph>
              {val.ocorrencia}
            </AnswerParagraph>
            {val.ocorrencia === renderBody.id && (
              <Tooltip title={`${t('Reports.subitemIdentifier')}`}>
                <InfoIcon style={{ marginLeft: '5px', color: '#643E91', alignSelf: 'center' }} />
              </Tooltip>
            )}
          </RowContainer>
        </>
      ))}
    </AnswersContainer>
  );
}


type params = {
  qrCodeData: string;
  renderBody: CreateUpdateBody;
  modeloQrCode: ModeloQRCode;
  hideSpan?: boolean;
};

export default function RenderQrCode({ qrCodeData, renderBody, modeloQrCode, hideSpan }: params) {
  let isPrinting = false;
  const { t } = useTranslation('translation');
  const [state, convertToPng, ref] = useToPng<HTMLDivElement>({
    onSuccess: data => {
      if (isPrinting) {
        OpenPrintBase64(data);
        isPrinting = false;
      } else {
        const a = document.createElement("a");
        a.href = data;
        a.download = `QrCode-${renderBody.id}.png`;
        a.click();
      }
    }
  });

  return (
    <QrCodeWithButtonsContainer>
      {!hideSpan && (
        <span
          className='tag is-warning'
          style={{ marginBottom: '10px' }}
        >
          {t('Reports.qrCodeAlreadyExists')}
        </span>
      )}
      <QRCodeDiv ref={ref}>
        <QRCode
          size={256}
          style={{ width: "80%" }}
          value={qrCodeData}
        />
        <TitleQR>{renderBody.nome}</TitleQR>
      </QRCodeDiv>
      <ContentContainer>
        <Accordion style={{ marginTop: '10px' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {t('Reports.showPreFilledResponses')}
          </AccordionSummary>
          <AccordionDetails>
            <RenderOptions renderBody={renderBody} modeloQrCode={modeloQrCode} />
          </AccordionDetails>
        </Accordion>
      </ContentContainer>
      <ButtonsQR>
        <button
          className='button is-success is-small'
          onClick={() => {
            isPrinting = true;
            convertToPng();
          }}
          disabled={state.isLoading}
        >
          {t('Reports.print')}&nbsp;
          <LocalPrintshopIcon />
        </button>
        <button
          className='button is-info is-small'
          onClick={() => convertToPng()}
          disabled={state.isLoading}
        >
          {t('Reports.download')}&nbsp;
          <DownloadIcon />
        </button>
      </ButtonsQR>
    </QrCodeWithButtonsContainer>
  );
}
